import { CompanySocialMedia } from '../../../pages/CompanyProfiles/Summary/components/CompanySocialMedia';
import { IBaseFieldProps } from './types';

export function FieldCompanySocialLinks(props: IBaseFieldProps<unknown>) {
  return <CompanySocialMedia socials={props.formProps.value} />;
}
